import { Injectable } from '@angular/core';
import { BaseProvider } from '../../../shared/providers/base-provider';
import { ScaleNotifier } from './scale-notifier';
import { ScaleState } from './scale-state';

@Injectable()
export class ScaleProvider extends BaseProvider<ScaleNotifier, ScaleState> {
  constructor() {
    super(ScaleNotifier);
  }
}
